/* assets/mobile-product-dots.js
   Dots móviles sincronizados con la galería de producto en Palo Alto 9
*/
(function () {
  'use strict';

  // Solo móvil
  var mq = window.matchMedia('(max-width: 749px)');
  if (!mq.matches) return;

  var $  = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var slides      = [];
  var currentIdx  = 0;
  var dotsWrapper = null;

  // Solo en PDP
  var isPDP =
    document.body.classList.contains('template-product') ||
    !!document.querySelector('[data-product-single-media-slider]');

  if (!isPDP) return;

  /* ================== FLICKITY HELPERS ================== */

  function getSliderElement() {
    // contenedor principal de la galería
    var slider = $('[data-product-single-media-slider]');
    if (!slider) return null;

    // Palo Alto añade .flickity-enabled al elemento con Flickity
    if (slider.classList.contains('flickity-enabled')) return slider;

    var inner = slider.querySelector('.flickity-enabled');
    return inner || slider;
  }

  function getFlickityInstance(el) {
    if (!el || !window.theme || !window.theme.Flickity || !window.theme.Flickity.data) return null;
    return window.theme.Flickity.data(el);
  }

  function collectSlides(el) {
    // todas las slides dentro del contenedor flickity
    slides = $$(
      '.product-gallery__media-slide, [data-product-single-media-wrapper]',
      el
    );
    if (!slides.length) {
      slides = $$('.product-gallery__media-slide', el) || $$('.product-gallery__media-slide');
    }
    slides.forEach(function (s, i) { s.dataset.idx = i; });
  }

  /* ================== DOTS ================== */

  function renderDots() {
    if (!slides.length) return;

    if (dotsWrapper && dotsWrapper.parentNode) {
      dotsWrapper.parentNode.removeChild(dotsWrapper);
    }

    dotsWrapper = document.createElement('div');
    dotsWrapper.className = 'mobile-dots-container';

    slides.forEach(function (_, i) {
      var dot = document.createElement('span');
      dot.className   = 'dot' + (i === currentIdx ? ' active' : '');
      dot.dataset.idx = String(i);
      dot.addEventListener('click', function () {
        changeSlide(i);
      }, { passive: true });
      dotsWrapper.appendChild(dot);
    });

    var galleryRoot =
      $('.product-gallery') ||
      (slides[0] && slides[0].closest('.product-gallery')) ||
      $('[data-product-single-media-slider]') ||
      document.body;

    if (!galleryRoot) return;

    var cs = window.getComputedStyle(galleryRoot);
    if (cs.position === 'static') {
      galleryRoot.style.position = 'relative';
    }

    galleryRoot.appendChild(dotsWrapper);
  }

  function setActiveDot(idx) {
    currentIdx = idx;
    if (!dotsWrapper) return;
    $$('.dot', dotsWrapper).forEach(function (d) {
      d.classList.toggle('active', Number(d.dataset.idx) === idx);
    });
  }

  /* ================== CAMBIAR SLIDE DESDE DOT ================== */

  function changeSlide(idx) {
    var sliderEl = getSliderElement();
    if (!sliderEl) return;

    var flkty = getFlickityInstance(sliderEl);
    if (flkty) {
      flkty.select(idx); // el evento 'select' se encargará de actualizar el dot
      return;
    }

    // Fallback por si por algún motivo Flickity no está disponible
    var target = slides[idx];
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    setActiveDot(idx);
  }

  /* ================== BIND DE EVENTOS DEL SLIDER ================== */

  function bindFlickityEvents(sliderEl, flkty) {
    // al seleccionar slide (por swipe, flechas, cambio de variante, etc.)
    flkty.on('select', function () {
      setActiveDot(flkty.selectedIndex);
    });
  }

  /* ================== INIT ================== */

  function initOnceReady() {
    var sliderEl = getSliderElement();
    if (!sliderEl) return false;

    var flkty = getFlickityInstance(sliderEl);
    if (!flkty) return false;

    collectSlides(sliderEl);
    if (!slides.length) return false;

    currentIdx = flkty.selectedIndex || 0;
    renderDots();
    bindFlickityEvents(sliderEl, flkty);
    setActiveDot(currentIdx);

    return true;
  }

  function init() {
    if (initOnceReady()) return;

    // Esperar hasta que el theme inicialice Flickity
    var mo = new MutationObserver(function () {
      if (initOnceReady()) mo.disconnect();
    });

    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { passive: true });
  } else {
    init();
  }
})();